/** 外链集中配置（非敏感） */
export const appLinks = {
  googlePlay: 'https://play.google.com/store/apps',
  telegram: 'https://t.me/Minego_Support',
  whatsapp: 'https://wa.me/15551234567',
} as const
